import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { ServiceManagementRoutes } from '@linkdev/service-management-library';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
})
export class HomepageComponent implements OnInit  {

  showServiceCatalog: boolean = true;
  isAdvancedSearchOpen: boolean = false;
  translation: any;
  isA2HSBtn: boolean = false;
  deferredPrompt: any;

  workspaceLink = `${ServiceManagementRoutes.baseRoute}/${ServiceManagementRoutes.workspaceRoute}`;
  servicesLink: string = `${ServiceManagementRoutes.baseRoute}/${ServiceManagementRoutes.serviceCardsRoute}`;
  shootingStarsArray = Array(6).fill(0); // 6 shooting stars in first night
  shootingStarsArray2 = Array(5).fill(0); // 5 shooting stars in second night
  serviceCatalogLoaded: boolean = false;
  
  constructor(private translateService: TranslateService
  ) {
    this.translateService.get("homePage").subscribe((trans) => {
      this.translation = trans;
      document.title = this.translation["documentTitle"] || "ServeBig";
    })
  }
  ngOnInit(): void {
    this.handleBrowserInstallPrompt();
  }
  trackByIndex(index: number): number {
    return index;
  }
   

  handleBrowserInstallPrompt() {
    window.addEventListener('beforeinstallprompt', (e) => {
      this.deferredPrompt = e;
      this.isA2HSBtn = true;
    });
  }
  serviceCatalogComponentLoaded(event: any) {
    this.serviceCatalogLoaded = true; // Set to true once loaded
  }

  appInstallHandler() {
    this.deferredPrompt.prompt();
    this.deferredPrompt.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === 'accepted') {
        this.isA2HSBtn = false;
      }
    });
  }


  toggleAdvancedSearch() {
    this.isAdvancedSearchOpen = !this.isAdvancedSearchOpen;
  }
}
